import { UniBoxAdditional as Component } from "./UniBoxAdditional";
import {
    UniBoxAdditionalSlotBottom as SlotBottom,
    UniBoxAdditionalSlotBottomLeft as SlotBottomLeft,
    UniBoxAdditionalSlotBottomRight as SlotBottomRight,
    UniBoxAdditionalSlotLeft as SlotLeft,
    UniBoxAdditionalSlotMiddle as SlotMiddle,
    UniBoxAdditionalSlotRight as SlotRight,
    UniBoxAdditionalSlotTop as SlotTop,
    UniBoxAdditionalSlotTopLeft as SlotTopLeft,
    UniBoxAdditionalSlotTopRight as SlotTopRight,
} from "./components/Slot/UniBoxAdditionalSlot";

interface IUniBoxAdditionalExtensions {
    SlotBottom: typeof SlotBottom;
    SlotBottomLeft: typeof SlotBottomLeft;
    SlotBottomRight: typeof SlotBottomRight;
    SlotLeft: typeof SlotLeft;
    SlotMiddle: typeof SlotMiddle;
    SlotRight: typeof SlotRight;
    SlotTop: typeof SlotTop;
    SlotTopLeft: typeof SlotTopLeft;
    SlotTopRight: typeof SlotTopRight;
}

export const UniBoxAdditional: typeof Component & IUniBoxAdditionalExtensions =
    Object.assign(Component, {
        SlotBottom,
        SlotBottomLeft,
        SlotBottomRight,
        SlotLeft,
        SlotMiddle,
        SlotRight,
        SlotTop,
        SlotTopLeft,
        SlotTopRight,
    });

export type { UniBoxAdditionalProps } from "./types";
